<div class="box">
  <div class="box__input" *ngIf="uploadBoxVisible" [ngClass]="{ 'border-error': errorMessage }">
    <label for="file-input">
      <app-icon name="cloud-upload"></app-icon>
    </label>
    <input
      class="cursor-pointer"
      id="file-input"
      type="file"
      [accept]="accetable"
      (change)="onUploadFile($event)"
      [multiple]="multipleSelection"
    />
    <span class="box__input--title" i18n>Przeciągnij plik lub kliknij, aby wybrać</span>
  </div>
  <span class="form-text text-danger">{{ errorMessage }}</span>
  <div class="box__files">
    <div class="box__files__file" *ngFor="let item of files; let index = index; trackBy: trackByFn">
      <div class="row">
        <div class="col-10">
          <div class="box__files__file__left align-items-end row">
            <div class="col-2 text-center">
              <app-icon name="file-alt"></app-icon>
            </div>
            <div class="col-10">
              <em>
                {{ item.name }}
              </em>
            </div>
          </div>
        </div>
        <div class="col-2">
          <div class="d-flex justify-content-center">
            <button ndt-icon-button type="button" aria-label="Usuń" i18n-aria-label (click)="deleteFile(index)">
              <app-icon name="trash"></app-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="accetable" class="form-text text-info">
    <ng-container i18n>Dopuszczalne rozszerzenia plików</ng-container>: {{ accetable }}
  </div>
</div>
